import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AdminType,
  ChangeUserBranchCommand,
  CreateUserCommand,
  ResetPasswordCommand,
  User,
} from "../users/users.model";
import { FormBuilder, Validators } from "@angular/forms";
import { UsersService } from "../users/users.service";
import { MatDialog } from "@angular/material/dialog";
import { Branch } from "../master-data/master-data.model";
import { finalize } from "rxjs/operators";
import { BranchesService } from "../branches/branches.service";
import { AdminEditComponent } from "../users/admin-edit/admin-edit.component";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: "app-branch-admins",
    templateUrl: "./branch-admins.component.html",
    styleUrls: ["./branch-admins.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BranchAdminsComponent implements OnInit {
  private usersService = inject(UsersService);
  private branchesService = inject(BranchesService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private formBuilder = inject(FormBuilder);
  dialog = inject(MatDialog);

  private adminsBS$ = new BehaviorSubject<User[]>([]);
  admins$ = this.adminsBS$.asObservable();
  selectedAdmin: User = null;
  branches: Branch[] = [];
  resettingPassword = false;
  selectedBranchUuid: string;

  form = this.formBuilder.group({
    manualPassword: [false],
    password: [""],
    forceLogout: [false],
  });
  hidePass = true;
  editBranch = false;
  adminType: AdminType = AdminType.BranchAdmin;

  get passwordInput() {
    return this.form.controls.password;
  }

  ngOnInit(): void {
    this.loadBranches();
    this.loadAdmins();
  }

  loadBranches() {
    this.branchesService.getAllBranches().subscribe((brs) => {
      this.branches = brs;
    });
  }

  loadAdmins() {
    this.usersService.getBranchAdmins().subscribe({
      next: (adm) => {
        this.adminsBS$.next(adm);
        if (this.selectedAdmin != null) {
          const idx = adm.findIndex((a) => a.uuid === this.selectedAdmin.uuid);
          if (idx !== -1) {
            this.selectedAdmin = adm[idx];
          }
        }
      },
      error: (err) => console.log("ERROR when loading chain admins"),
    });
  }

  clearForm() {
    this.hidePass = true;
    this.form.controls.manualPassword.setValue(false);
    this.form.controls.forceLogout.setValue(false);
    this.passwordInput.setValue("");
    this.passwordInput.clearValidators();
  }

  onBack() {
    this.router.navigate(["/"]).then();
  }

  onAddAdmin() {
    const dat = {
      type: AdminType.BranchAdmin,
      user: new User(),
    };
    const dialogRef = this.dialog.open(AdminEditComponent, {
      width: "40vw",
      data: dat,
    });
    dialogRef.afterClosed().subscribe((data: CreateUserCommand) => {
      if (data != null) {
        console.log("New branch Admin", data);
        this.usersService
          .addAdmin(data)
          .pipe(finalize(() => this.loadAdmins()))
          .subscribe();
      }
    });
  }

  resetPassword(uuid: string) {
    console.log("Reset password", uuid);
    const cr: ResetPasswordCommand = {
      userUuid: uuid,
      manualSetPassword: this.form.value.manualPassword,
      password: this.passwordInput.value,
      logoutUser: this.form.value.forceLogout,
    };
    this.usersService.resetUserPassword(cr).subscribe({
      next: () => {
        this.resettingPassword = false;
        this.clearForm();
      },
      error: () => {
        this.resettingPassword = false;
        this.clearForm();
        console.log("Password reset Error");
      },
    });
  }

  setManualPassword() {
    this.passwordInput.setValue("");
    if (this.form.controls.manualPassword?.value === true) {
      this.passwordInput.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$"),
      ]);
    } else {
      this.passwordInput.clearValidators();
    }

    this.passwordInput.updateValueAndValidity();
  }

  closeResetForm() {
    this.resettingPassword = false;
    this.clearForm();
  }

  onAdminSelected(user: User) {
    console.log("USER", user);
    this.selectedAdmin = user;
  }

  clearSelection() {
    this.selectedAdmin = null;
  }

  clearBranch() {
    this.selectedBranchUuid = null;
  }

  saveBranch() {
    this.editBranch = false;
    const command: ChangeUserBranchCommand = {
      branchUuid: this.selectedBranchUuid,
      userUuid: this.selectedAdmin.uuid,
    };
    this.usersService.changeBranchForUser(command).subscribe((res) => {
      if (res === true) {
        this.loadAdmins();
      }
    });
  }

  closeEdit() {
    this.editBranch = false;
  }

  onEditBrach() {
    this.editBranch = true;
    console.log("SEL BRA", this.selectedAdmin.branch.uuid);
    this.selectedBranchUuid = this.selectedAdmin.branch.uuid;
  }
}
